import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup, { RadioGroupProps } from "@material-ui/core/RadioGroup";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import GenderFrequencyIcon from "./GenderFrequencyIcon";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { getFirestore } from "redux-firestore";
import "./Gender.scss";
import WordSummary from "../dashboard/WordSummary";
import FavoriteIcon from "@material-ui/icons/FavoriteTwoTone";
import SkipIcon from "@material-ui/icons/HighlightOffTwoTone";
import VisibilityIcon from "@material-ui/icons/VisibilityTwoTone";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOffTwoTone";
import LooksOneTwoToneIcon from "@material-ui/icons/LooksOneTwoTone";
import LooksTwoTwoToneIcon from "@material-ui/icons/LooksTwoTwoTone";
import Looks3TwoToneIcon from "@material-ui/icons/Looks3TwoTone";
import Looks4TwoTone from "@material-ui/icons/Looks4TwoTone";
import Looks5TwoTone from "@material-ui/icons/Looks5TwoTone";
import Looks6TwoTone from "@material-ui/icons/Looks6TwoTone";
import Looks7TwoTone from "@material-ui/icons/Filter7TwoTone";
import EditIcon from "@material-ui/icons/EditTwoTone";
import DateIcon from "@material-ui/icons/ScheduleTwoTone";
import ShuffleIcon from "@material-ui/icons/ShuffleTwoTone";

const GenderMenu = (props) => {
  const handleBookmarkClick = () => {
    UpdateField("Bookmark", !props.Word.Bookmark);
  };
  const handleDateClick = () => {
    UpdateField("createdAt", new Date());
  };

  const handleEditClick = () => {
    //UpdateField('Bookmark', !props.Word.Bookmark)
    //props.handleBookmarkClick();
    props.handleEditRedirect();
  };

  const UpdateField = (name, value) => {
    let id = props.Word.id;
    const firestore = getFirestore();
    firestore
      .collection("gender")
      .doc(id)
      .update({
        [name]: value,
      });
    props.UpdateField(name, value);
  };

  const handleSkipClick = () => {
    UpdateField("Skip", !props.Word.Skip);
    //  props.handleSkipClick();
  };

  const ClickLevel = () => {
    var level = props.Word.Level;
    if (level == undefined) {
      level = 1;
    }
    level += 1;
    if (level > 7) {
      level = 1;
    }
    UpdateField("Level", level);
    //  props.handleLevelClick(level);
  };

  let level = (
    <IconButton onClick={() => ClickLevel()}>
      <LooksOneTwoToneIcon />
    </IconButton>
  );

  if (props.Word.Level != undefined) {
    if (props.Word.Level == 2) {
      level = (
        <IconButton onClick={() => ClickLevel()} className="orange">
          <LooksTwoTwoToneIcon />
        </IconButton>
      );
    } else if (props.Word.Level == 3) {
      level = (
        <IconButton onClick={() => ClickLevel()} className="orange">
          <Looks3TwoToneIcon />
        </IconButton>
      );
    } else if (props.Word.Level == 4) {
      level = (
        <IconButton onClick={() => ClickLevel()} className="orange">
          <Looks4TwoTone />
        </IconButton>
      );
    } else if (props.Word.Level == 5) {
      level = (
        <IconButton onClick={() => ClickLevel()} className="orange">
          <Looks5TwoTone />
        </IconButton>
      );
    } else if (props.Word.Level == 6) {
      level = (
        <IconButton onClick={() => ClickLevel()} className="orange">
          <Looks6TwoTone />
        </IconButton>
      );
    } else if (props.Word.Level == 7) {
      level = (
        <IconButton onClick={() => ClickLevel()} className="orange">
          <Looks7TwoTone />
        </IconButton>
      );
    }
  }

  return (
    <section className="menu">
      <div className="menu__item1">
        <GenderFrequencyIcon
          UpdateField={UpdateField}
          frequency={props.Word.Frequency}
        ></GenderFrequencyIcon>
        {/* <span className={`box ${props.Word.Frequency ? 'orange' : ''}`}>
          {props.Word.Frequency}
        </span> */}
      </div>
      {level}
      {/* <div onClick={() => ClickLevel()} className="menu__item">
        {props.Word.Level}
      </div> */}
      {/* <div onClick={() => handleSkipClick()} className="menu__item">
        <span className={`box ${props.Word.Skip ? 'orange' : ''}`}>Skip</span>
      </div> */}
      <IconButton
        className={`box ${props.Word.Skip ? "orange" : ""}`}
        onClick={() => handleSkipClick()}
        color="default"
      >
        <SkipIcon />
      </IconButton>
      <IconButton
        className={`box ${props.ShowAll ? "orange" : ""}`}
        onClick={() => props.handleShowAllClick()}
        color="default"
      >
        {props.ShowAll ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>

      {/* Bookmark works I commented it */}
      {/* <IconButton
        className={`box ${props.Word.Bookmark ? 'orange' : ''}`}
        onClick={() => handleBookmarkClick()}
        color="default"
      >
        <FavoriteIcon />
      </IconButton> */}
      <IconButton onClick={() => handleDateClick()} color="default">
        <DateIcon />
      </IconButton>
      <IconButton onClick={() => props.Shuffle()} color="default">
        <ShuffleIcon />
      </IconButton>
      <IconButton onClick={() => handleEditClick()} color="default">
        <EditIcon />
      </IconButton>
      <div className="menu__counter">
        {props.SelectedIndex} / {props.Counter}
      </div>
    </section>
  );
};

export default GenderMenu;
